(function () {
    'use strict';

    angular
        .module('app.editableText', [
            'app.core',
            'app.editableText.preview',
            'utils',
            'textAngular']);
})();